import { HttpClient } from '@angular/common/http';
import { AccountService } from 'src/app/services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/account.service";
export class FecharOSService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    fecharOS(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/os-fechamento-web`, data, { headers: this.account.composeHeaders() });
    }
    uploadPhotos(photos, uploadPhotos) {
        const formData = new FormData();
        for (const f of photos) {
            formData.append('photos', f);
        }
        formData.append('jsonuploadphoto', JSON.stringify(uploadPhotos));
        return this.http.post(`${SCAMP_API.accountApiV1}/os-fechamento/upload/fotos/web`, formData, { headers: this.account.composeHeaders() });
    }
    uploadPhotos2(photos, OSFechamentoId) {
        const formData = new FormData();
        for (const f of photos) {
            formData.append('photos', f);
        }
        formData.append('OSFechamentoId', OSFechamentoId);
        return this.http.post(`${SCAMP_API.accountApiV1}/os-fechamento/upload/fotos/mobil`, formData, { headers: this.account.composeHeaders() });
    }
    removerOSFechamentoIrregularidade(irregularidadeId, osFechamentoId) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/osfechamentoirregularidade/remove/${irregularidadeId}/${osFechamentoId}`, { headers: this.account.composeHeaders() });
    }
    removerOSFechamentoMovOrdemMaterial(materialId, osFechamentoId) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/osfechamentomovordemmaterial/remove/${materialId}/${osFechamentoId}`, { headers: this.account.composeHeaders() });
    }
    getFotoBase64(arquivoNome) {
        return this.http.post(`${SCAMP_API.accountApiV1}/fotobase64/download`, arquivoNome, { headers: this.account.composeHeaders() });
    }
    getArrayFotosBase64(uploadPhotos) {
        return this.http.post(`${SCAMP_API.accountApiV1}/array-fotos-base64/download`, uploadPhotos, { headers: this.account.composeHeaders() });
    }
}
FecharOSService.ngInjectableDef = i0.defineInjectable({ factory: function FecharOSService_Factory() { return new FecharOSService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: FecharOSService, providedIn: "root" });
